require('../modules/web.dom.iterable');
require('../modules/es6.string.iterator');
module.exports = require('../modules/core.get-iterator');



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src727013012/src/~/core-js/library/fn/get-iterator.js
// module id = crD7
// module chunks = 6